// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/dylo-dev-logo-full.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/dylo-dev-logo-mark.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor sticky de toda la barra (transparente): apila las dos cards */
.Sidebar_sidebar__Oyk2S {
  position: sticky;
  top: 16px;
  align-self: flex-start;
  height: calc(100vh - 32px);
  width: 248px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: width 0.22s ease;
}
.Sidebar_sidebar__Oyk2S.Sidebar_collapsed__PuEC6 {
  width: 84px;
}

/* ============================================================
   MÓVIL: el sidebar pasa a drawer (off-canvas)
   ============================================================
   Antes no había NINGUNA media query aquí, así que en un teléfono el sidebar
   conservaba sus 248px (u 84px colapsado) y \`height: calc(100vh - 32px)\`: se
   veía como una columna angosta y altísima, y al ser \`sticky\` se deslizaba
   ENCIMA del contenido al hacer scroll (por eso tapaba "Back to list").

   Ahora se saca del flujo y se muestra solo cuando el usuario lo pide con el
   botón de menú. La animación usa **solo opacidad y escala**, nunca
   desplazamiento, según la convención del proyecto. */
@media (max-width: 720px) {
  /**
   * Drawer anclado a la DERECHA.
   *
   * Antes salía por la izquierda, heredado de la posición del sidebar de escritorio, y con
   * el botón de menú también a la izquierda. Se cambió a la derecha por dos razones: es
   * donde llega el pulgar sin recolocar la mano, y el panel aparece **desde el mismo borde
   * donde está el botón** que lo abrió, así que la relación causa-efecto se ve. Eso era
   * parte de la sensación de "está raro": el gesto y el resultado ocurrían en lados
   * opuestos de la pantalla.
   */
  .Sidebar_sidebar__Oyk2S {
    position: fixed;
    top: 0;
    right: 0;
    left: auto;
    height: 100vh;
    /* Ancho cómodo para el pulgar, sin comerse toda la pantalla. */
    width: min(88vw, 320px);
    /* \`env(safe-area-inset-*)\` respeta la muesca y la barra de gestos del teléfono. */
    padding: calc(10px + env(safe-area-inset-top, 0px)) 12px
      calc(12px + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;
    z-index: 120;
    overflow-y: auto;
    /* Oculto por omisión: no se puede tocar ni tabular. */
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    /**
     * ⚠️ **Solo opacidad y escala, nunca desplazamiento**, según la convención del
     * proyecto. Un drawer normalmente se deslizaría con \`translateX\`; aquí se logra la
     * misma lectura escalando desde el borde donde nace (\`transform-origin: top right\`):
     * el panel crece desde la esquina del botón en lugar de aparecer de golpe.
     */
    transform: scale(0.94);
    transform-origin: top right;
    transition: opacity 0.22s ease, transform 0.24s cubic-bezier(0.22, 1, 0.36, 1),
      visibility 0.24s;
    /**
     * Fondo de **cristal**, igual que el header móvil: translúcido con difuminado fuerte.
     *
     * Antes era opaco (\`--dylo-page-bg\`) y el drawer se sentía como otra pantalla encima. Con
     * transparencia se percibe como una capa sobre el contenido, que es lo que es. El 72% es
     * más opaco que el header a propósito: aquí hay texto de menú que debe leerse sin dudas,
     * y las tarjetas internas ya traen su propio fondo.
     */
    background: color-mix(in srgb, var(--dylo-page-bg) 72%, transparent);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    /* Sombra hacia el interior de la pantalla: refuerza que es una capa sobre el contenido. */
    box-shadow: -18px 0 40px rgba(0, 0, 0, 0.35);
  }

  /**
   * 🔑 Las tarjetas de dentro también translúcidas.
   *
   * El panel ya era de cristal, pero **no se notaba**: \`.logoCard\` y \`.navCard\` llevan
   * \`--dylo-surface\` opaco y entre las dos cubren casi todo el drawer, así que la
   * transparencia solo asomaba por los 12px de padding. El efecto vive o muere aquí.
   *
   * La tarjeta del logo va más transparente que la de las opciones: ahí no hay texto que
   * leer, solo el logotipo, así que aguanta más cristal sin perder legibilidad.
   */
  /* ⚠️ Se escriben como \`.sidebar .logoCard\` porque las reglas base están **después** en el
     archivo y, con la misma especificidad, ganaría el orden aunque estas vivan en un \`@media\`.
     Es la misma trampa que ya costó un intento con el encabezado del drawer. */
  .Sidebar_sidebar__Oyk2S .Sidebar_logoCard__j4yua {
    background: color-mix(in srgb, var(--dylo-surface) 45%, transparent);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
  }

  .Sidebar_sidebar__Oyk2S .Sidebar_navCard__fYsaY {
    background: color-mix(in srgb, var(--dylo-surface) 62%, transparent);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
  }

  /**
   * 🔑 En móvil el menú NO scrollea por dentro: scrollea el drawer completo.
   *
   * El drawer ya tiene \`overflow-y: auto\` y \`height: 100vh\` unas reglas más arriba,
   * así que dejar el scroll de \`.nav\` daría **dos áreas anidadas que scrollean**. En
   * un teléfono eso es de lo más molesto que hay: el dedo mueve una o la otra según
   * dónde empezó el gesto, y el pie del panel se quedaría fijo a media pantalla en
   * lugar de estar al final del menú, que es donde se espera.
   *
   * Y el problema que motivó el scroll de escritorio aquí no existe: el drawer mide
   * \`100vh\` fijo, no crece.
   *
   * ⚠️ Va como \`.sidebar .nav\` / \`.sidebar .navCard\` a propósito. Las reglas base
   * están **después** en este archivo, así que con la misma especificidad ganarían
   * por orden aunque estas vivan dentro del \`@media\`. Es la tercera vez que este
   * archivo cobra esa trampa.
   */
  .Sidebar_sidebar__Oyk2S .Sidebar_nav__lOtqS {
    /* 🔄 21-oct-2026: \`1 1 auto\` y no \`0 0 auto\`. \`.navScroll\` es un flex en **fila**, así que aquí \`flex\` decide el
       ancho, no el alto: con \`0 0 auto\` el menú medía lo que su opción más larga ("Create Shipment") y la pastilla
       naranja de la opción activa se cortaba antes del borde de la tarjeta. Lo que quita el scroll interno es
       \`.sidebar .navScroll { flex: 0 0 auto }\` (en la columna de la tarjeta) junto con el \`min-height: auto\` de aquí. */
    flex: 1 1 auto;
    min-height: auto;
    overflow-y: visible;
    overscroll-behavior: auto;
  }
  /* Sin área que scrollee no hay nada que insinuar, y el degradado quedaría flotando
     encima de las opciones. */
  .Sidebar_sidebar__Oyk2S .Sidebar_navScroll__5dU7Q {
    flex: 0 0 auto;
  }
  .Sidebar_sidebar__Oyk2S .Sidebar_navScroll__5dU7Q::after {
    display: none;
  }

  /**
   * Sin soporte de \`backdrop-filter\`, todo vuelve a ser opaco.
   *
   * Translúcido y **sin** difuminar dejaría el menú ilegible sobre el contenido: se leerían
   * los dos textos superpuestos. Es preferible perder el efecto que la legibilidad.
   */
  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    .Sidebar_sidebar__Oyk2S {
      background: var(--dylo-page-bg);
    }
    .Sidebar_sidebar__Oyk2S .Sidebar_logoCard__j4yua,
    .Sidebar_sidebar__Oyk2S .Sidebar_navCard__fYsaY {
      background: var(--dylo-surface);
    }
  }

  /**
   * Ya no hacen falta las anulaciones de \`.collapsed\` aquí: el componente **no aplica esa
   * clase en móvil** (ver \`shownCollapsed\` en \`Sidebar.tsx\`), así que el drawer siempre se
   * dibuja como el sidebar extendido — logo completo y opciones con texto. Antes se parchaba
   * desde el CSS y el logo seguía siendo el símbolo, porque cuál cargar lo decide JavaScript.
   */

  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: scale(1);
  }

  /**
   * Colapsar no tiene sentido en un drawer, y **dejar el botón visible era el otro motivo
   * de que se sintiera como una adaptación mal hecha**: un menú móvil no se "contrae".
   */
  /* 🔄 21-oct-2026: \`.sidebar .collapseBtn\` y no \`.collapseBtn\` solo. La regla base está **después** en este archivo y,
     con la misma especificidad, ganaba aunque esta viva en el \`@media\`: el botón seguía saliendo en el cajón, medio
     cortado contra el borde derecho de la pantalla. Es la trampa de las notas de arriba, otra vez. */
  .Sidebar_sidebar__Oyk2S .Sidebar_collapseBtn__LU91o {
    display: none;
  }

  /**
   * Entrada escalonada de las opciones.
   *
   * Aparecen en cascada en lugar de todas a la vez: da la sensación de que el menú se
   * despliega y guía la vista hacia abajo. Solo opacidad y escala.
   */
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > * {
    animation: Sidebar_dylo-drawer-item__2-5AE 0.26s cubic-bezier(0.22, 1, 0.36, 1) both;
  }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(1) { animation-delay: 40ms; }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(2) { animation-delay: 70ms; }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(3) { animation-delay: 100ms; }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(4) { animation-delay: 130ms; }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(5) { animation-delay: 155ms; }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(6) { animation-delay: 175ms; }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(7) { animation-delay: 195ms; }
  .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > *:nth-child(n + 8) { animation-delay: 210ms; }

  @keyframes Sidebar_dylo-drawer-item__2-5AE {
    from {
      opacity: 0;
      transform: scale(0.97);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  /* Quien pidió menos movimiento no lo recibe. */
  @media (prefers-reduced-motion: reduce) {
    .Sidebar_sidebar__Oyk2S {
      transition: opacity 0.12s ease, visibility 0.12s;
      transform: none;
    }
    .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu {
      transform: none;
    }
    .Sidebar_sidebar__Oyk2S.Sidebar_mobileOpen__m76Nu .Sidebar_nav__lOtqS > * {
      animation: none;
    }
  }
}



/* Card del logo (separada de las opciones) */
.Sidebar_logoCard__j4yua {
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--dylo-sidebar-border);
  border-radius: 20px;
  box-shadow: var(--shadow-card);
  padding: 10px 14px;
  height: 72px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.Sidebar_logo__Y3UPa {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
/* El card mantiene su altura fija; el símbolo (vertical) llena el alto disponible. */
.Sidebar_collapsed__PuEC6 .Sidebar_logoCard__j4yua {
  padding: 8px;
}
.Sidebar_collapsed__PuEC6 .Sidebar_logo__Y3UPa {
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

/* Card de navegación */
.Sidebar_navCard__fYsaY {
  position: relative;
  flex: 1 1;
  min-height: 0;
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--dylo-sidebar-border);
  border-radius: 20px;
  box-shadow: var(--shadow-card);
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
}

/* Botón de colapsar: sobre el borde derecho, a la altura de la primera opción */
.Sidebar_collapseBtn__LU91o {
  position: absolute;
  right: -13px;
  /* Centrado vertical con la primera opción (Dashboard):
     padding-top navCard 18 + medio item (~21) - medio botón (13) */
  top: 26px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1.5px solid var(--dylo-sidebar-border);
  background: #151515;
  color: var(--dylo-collapse-icon);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  z-index: 20;
  transition: transform 0.22s ease, background-color 0.15s ease;
}
.Sidebar_collapsed__PuEC6 .Sidebar_collapseBtn__LU91o {
  transform: rotate(180deg);
}

/* ============================================================
   Navegación — la parte que crece y scrollea
   ============================================================
   🔑 El menú siguió creciendo y llegó el punto en que no cabía: \`.nav\` no tenía
   \`overflow\`, así que se desbordaba de \`.navCard\`, el \`.spacer\` colapsaba a 0 y
   **\`.footerNav\` (Mode y My account) se iba fuera de la tarjeta**.

   La solución no es \`position: sticky\` en el pie, es darle a \`.nav\` el papel de
   absorber el crecimiento: \`flex: 1\` + \`min-height: 0\` + su propio scroll. Con
   eso \`.footerNav\` queda naturalmente clavado al fondo de la tarjeta por ser su
   hermano fuera del área que scrollea.

   ⚠️ Es mejor que \`sticky\` justamente por lo que ya tropezó este archivo:
   \`overflow\` en un ancestro **rompe** \`position: sticky\` de sus descendientes. Si
   el scroll viviera en \`.navCard\`, un pie sticky dentro dejaría de funcionar. Así
   el scroll está en \`.nav\` y el pie ni lo necesita.

   📌 \`min-height: 0\` no es opcional: el mínimo por omisión de un ítem flex es el
   tamaño de su contenido, así que sin esto \`.nav\` se niega a encogerse por debajo
   de la altura de todas las opciones juntas y no scrollea nunca. */
.Sidebar_nav__lOtqS {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  /* Al llegar al final del menú, el scroll NO se contagia a la página. Sin esto,
     seguir girando la rueda mueve el contenido de atrás y se siente roto. */
  overscroll-behavior: contain;
  /**
   * Barra de scroll oculta, a petición: lo que importa es que el sidebar no crezca
   * a lo alto, y una barra ahí competiría visualmente con las opciones.
   *
   * ⚠️ Contrapartida asumida: sin barra no hay señal de que haya más contenido
   * abajo. Se mitiga con el degradado de \`.navCard::after\`, que sí avisa.
   */
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.Sidebar_nav__lOtqS::-webkit-scrollbar {
  display: none;
}

/**
 * Envoltura del área que scrollea.
 *
 * Existe solo para poder anclar el degradado al **borde inferior del scroll**.
 *
 * 🔑 Por qué hace falta y no basta un pseudo-elemento:
 * - dentro de \`.nav\` se desplazaría con el contenido en lugar de quedarse en el
 *   borde, y
 * - sobre \`.navCard\` habría que posicionarlo con un \`bottom\` calculado a partir
 *   del alto del pie, que es un número mágico: se rompió en cuanto se agregó el
 *   bloque de Desarrollador encima del divisor.
 *
 * Con la envoltura, el degradado queda pegado al final del scroll pase lo que pase
 * debajo.
 */
.Sidebar_navScroll__5dU7Q {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
}
.Sidebar_navScroll__5dU7Q::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 22px;
  pointer-events: none;
  background: linear-gradient(to top, var(--dylo-surface), transparent);
  opacity: 0.9;
}
/* El wrapper del tooltip debe ocupar todo el ancho para no romper el item */
.Sidebar_navTooltip__xwDx1 {
  display: block;
  width: 100%;
}

.Sidebar_item__IT-N6 {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 11px 14px;
  border-radius: 12px;
  color: var(--dylo-text);
  font-size: 14.5px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.Sidebar_item__IT-N6:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);
  color: var(--dylo-ink);
}
.Sidebar_item__IT-N6 .Sidebar_icon__aHiGX {
  display: inline-flex;
  flex-shrink: 0;
  color: currentColor;
}
.Sidebar_itemActive__lqCsq {
  background: var(--dylo-orange);
  color: #fff;
}
.Sidebar_itemActive__lqCsq:hover {
  background: var(--dylo-orange-hover);
  color: #fff;
}

.Sidebar_collapsed__PuEC6 .Sidebar_item__IT-N6 {
  justify-content: center;
  padding: 11px 0;
}
.Sidebar_collapsed__PuEC6 .Sidebar_label__4zS\\+M {
  display: none;
}

/**
 * Pie del sidebar: el divisor, Mode y My account.
 *
 * \`flex-shrink: 0\` es la otra mitad del arreglo. Sin él, cuando el menú no cabe
 * el navegador reparte la falta de espacio entre los dos hermanos y el pie se
 * empieza a comprimir —que es la versión sutil del mismo problema— en lugar de
 * dejar que \`.nav\` scrollee.
 *
 * Ya no hace falta un \`.spacer\`: \`.nav\` tiene \`flex: 1\` y llena el hueco cuando
 * hay pocas opciones, así que el pie queda abajo igual.
 */
.Sidebar_footerNav__dBA0h {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 14px;
  border-top: 1px solid var(--dylo-line);
  flex-shrink: 0;
}

.Sidebar_modeBtn__GgAIE {
  border: none;
  background: transparent;
  text-align: left;
  font-family: var(--font-sans);
}

/* ===== Grupos colapsables del menú (submenú "Shipments") ===== */
.Sidebar_group__pWsGr {
  display: flex;
  flex-direction: column;
}

/* El toggle reutiliza .item para heredar tamaño, tipografía y hover */
.Sidebar_groupToggle__dibI8 {
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: var(--font-sans);
  text-align: left;
}
/* Se resalta cuando alguna vista del grupo está activa */
.Sidebar_groupActive__aJTET .Sidebar_label__4zS\\+M {
  color: var(--dylo-ink);
  font-weight: 600;
}

.Sidebar_chevron__hdbbx {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  opacity: 0.7;
  transition: transform 0.22s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease;
}
.Sidebar_chevronOpen__h2oux {
  transform: rotate(180deg);
  opacity: 1;
}

.Sidebar_groupChildren__oIfwk {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 2px 0 2px 0;
}
/* Guía vertical que agrupa visualmente a los hijos */
.Sidebar_groupChildren__oIfwk::before {
  content: '';
  position: absolute;
  left: 20px;
  top: 2px;
  bottom: 2px;
  width: 1.5px;
  border-radius: 2px;
  background: var(--dylo-line);
}

.Sidebar_groupChild__JkGOS {
  /* Solo opacidad: sin translate, para no disparar barras de scroll */
  animation: Sidebar_dylo-fade-in__UBGmS 0.24s ease both;
}

.Sidebar_itemNested__Nusuu {
  padding-left: 34px;
  font-size: 13px;
}

@media (prefers-reduced-motion: reduce) {
  .Sidebar_groupChild__JkGOS,
  .Sidebar_chevron__hdbbx {
    animation: none !important;
    transition: none !important;
  }
}

/* ============================================================
   Sección Desarrollador — paleta matrix
   ============================================================
   🔑 Los colores viven en **variables con alcance a este bloque**, no como valores
   fijos sueltos por la regla. Dos razones:

   1. Reescribir los tokens dentro de \`.devBlock\` hace que todo lo que herede de
      ellos —el \`.item\`, el hover, el estado activo, el chevron del grupo— se tiña
      solo, sin duplicar cada regla. Es el mismo recurso que usa la card
      \`spotlight\` del dashboard.
   2. Si estos colores se escribieran en los tokens globales o sin acotar, se
      filtrarían al resto de la aplicación y **romperían el modo claro**: un verde
      neón sobre fondo blanco es ilegible.

   Verde y negro fijos a propósito, iguales en claro y oscuro: la sección tiene que
   leerse como "esto es otra cosa, no es la aplicación normal" en los dos temas. Es
   la única parte del sistema que ignora el tema, y es deliberado. */
.Sidebar_devBlock__YkqLy {
  /* No se comprime: cuando el menú no cabe, el que scrollea es \`.nav\`. */
  flex-shrink: 0;
  margin-top: 10px;
  padding: 7px;
  border-radius: 14px;
  /* Ancla de las capas decorativas, que van en absoluto. */
  position: relative;
  /* Recorta el barrido del escáner y los pulsos en los bordes redondeados. */
  overflow: hidden;
  /* Aísla el apilamiento para que los z-index de dentro no compitan con el resto
     del sidebar ni con el botón de colapsar. */
  isolation: isolate;

  --matrix-green: #39ff88;
  --matrix-green-dim: #1f7a44;
  --matrix-bg: #050806;

  /**
   * Fondo en tres capas:
   * 1. rejilla fina de PCB (dos gradientes cruzados),
   * 2. resplandor difuso que sube desde el fondo, y
   * 3. el negro base.
   *
   * Se hace con gradientes y no con una imagen porque escala a cualquier tamaño sin
   * pedir un archivo extra, y porque el bloque cambia de ancho al colapsar el sidebar.
   */
  background-color: var(--matrix-bg);
  background-image: linear-gradient(
      color-mix(in srgb, var(--matrix-green) 5%, transparent) 1px,
      transparent 1px
    ),
    linear-gradient(
      90deg,
      color-mix(in srgb, var(--matrix-green) 5%, transparent) 1px,
      transparent 1px
    ),
    radial-gradient(
      120% 80% at 50% 130%,
      color-mix(in srgb, var(--matrix-green) 14%, transparent),
      transparent 70%
    );
  background-size: 14px 14px, 14px 14px, 100% 100%;

  border: 1px solid color-mix(in srgb, var(--matrix-green) 34%, transparent);
  /* Doble resplandor: uno interior de terminal y uno exterior que respira. */
  box-shadow: inset 0 0 22px color-mix(in srgb, var(--matrix-green) 9%, transparent),
    0 0 0 0 color-mix(in srgb, var(--matrix-green) 30%, transparent);
  animation: Sidebar_dev-breathe__f4Iyi 3.6s ease-in-out infinite;
}

/*
  El resplandor exterior late. Se anima \`box-shadow\` y NO \`transform\`: escalar el bloque
  movería el pie del sidebar en cada latido, que es justo el tipo de animación que este
  proyecto tiene prohibida por las barras de scroll parásitas.
*/
@keyframes Sidebar_dev-breathe__f4Iyi {
  0%,
  100% {
    box-shadow: inset 0 0 22px color-mix(in srgb, var(--matrix-green) 9%, transparent),
      0 0 6px color-mix(in srgb, var(--matrix-green) 12%, transparent);
    border-color: color-mix(in srgb, var(--matrix-green) 30%, transparent);
  }
  50% {
    box-shadow: inset 0 0 26px color-mix(in srgb, var(--matrix-green) 14%, transparent),
      0 0 14px color-mix(in srgb, var(--matrix-green) 22%, transparent);
    border-color: color-mix(in srgb, var(--matrix-green) 52%, transparent);
  }
}

/* El contenido va sobre la decoración. */
.Sidebar_devContent__ObclH {
  position: relative;
  z-index: 1;
}

/**
 * Barrido de escáner.
 *
 * Una línea que recorre el bloque de arriba abajo, como el refresco de un monitor
 * viejo. Se anima \`top\`, y es seguro **porque el elemento está en absoluto**: no
 * participa del flujo, así que no puede empujar nada ni disparar una barra de scroll.
 * Es la misma excepción que ya se usó con el vehículo del conector.
 */
.Sidebar_scanline__Mhm5U {
  position: absolute;
  left: 0;
  right: 0;
  height: 34px;
  pointer-events: none;
  z-index: 0;
  background: linear-gradient(
    to bottom,
    transparent,
    color-mix(in srgb, var(--matrix-green) 10%, transparent) 45%,
    color-mix(in srgb, var(--matrix-green) 18%, transparent) 50%,
    transparent
  );
  animation: Sidebar_dev-scan__F9r8p 5.5s linear infinite;
}

@keyframes Sidebar_dev-scan__F9r8p {
  from {
    top: -34px;
    opacity: 0;
  }
  12% {
    opacity: 1;
  }
  88% {
    opacity: 1;
  }
  to {
    top: 100%;
    opacity: 0;
  }
}

/* Se reescriben los tokens que consume \`.item\`, así hereda todo el bloque. */
.Sidebar_devBlock__YkqLy .Sidebar_item__IT-N6,
.Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8 {
  color: var(--matrix-green);
  /* Monoespaciada: es la señal más rápida de "herramienta técnica". */
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  /* Resplandor del texto, como fósforo en un CRT. Muy leve: más y se vuelve ilegible. */
  text-shadow: 0 0 6px color-mix(in srgb, var(--matrix-green) 45%, transparent);
}
.Sidebar_devBlock__YkqLy .Sidebar_item__IT-N6:hover,
.Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8:hover {
  background: color-mix(in srgb, var(--matrix-green) 14%, transparent);
  color: #eaffef;
  text-shadow: 0 0 9px color-mix(in srgb, var(--matrix-green) 75%, transparent);
}

/**
 * El icono del procesador late, y el latido está **desfasado** del resplandor del
 * bloque (3.6s vs 2.4s). Si fueran iguales todo pulsaría al unísono y se leería como
 * una sola animación en bucle; desfasados parece actividad.
 */
.Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8 .Sidebar_icon__aHiGX {
  animation: Sidebar_dev-chip__8avMi 2.4s ease-in-out infinite;
}

@keyframes Sidebar_dev-chip__8avMi {
  0%,
  100% {
    filter: drop-shadow(0 0 1px color-mix(in srgb, var(--matrix-green) 40%, transparent));
    opacity: 0.85;
  }
  50% {
    filter: drop-shadow(0 0 5px var(--matrix-green));
    opacity: 1;
  }
}

/**
 * Cursor de terminal parpadeando al final de la etiqueta del grupo.
 *
 * Se dibuja con \`::after\` sobre el \`.label\` para no meter un nodo más en el TSX, y usa
 * \`opacity\` en pasos duros (\`steps\`) porque un cursor de consola no se desvanece: está
 * o no está.
 */
.Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8 .Sidebar_label__4zS\\+M::after {
  content: '_';
  margin-left: 3px;
  animation: Sidebar_dev-caret__cW5R2 1.1s steps(1) infinite;
}

@keyframes Sidebar_dev-caret__cW5R2 {
  0%,
  49% {
    opacity: 1;
  }
  50%,
  100% {
    opacity: 0;
  }
}

/* Colapsado no hay etiqueta, así que el cursor no aplica. */
.Sidebar_collapsed__PuEC6 .Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8 .Sidebar_label__4zS\\+M::after {
  content: none;
}

/*
  El estado activo NO usa el naranja de marca: si un ítem de esta sección se
  pintara naranja, dejaría de leerse como parte del bloque y parecería un error de
  estilo. Verde sólido sobre negro mantiene la unidad.
*/
.Sidebar_devBlock__YkqLy .Sidebar_itemActive__lqCsq,
.Sidebar_devBlock__YkqLy .Sidebar_itemActive__lqCsq:hover {
  background: color-mix(in srgb, var(--matrix-green) 22%, transparent);
  color: #eaffef;
  box-shadow: inset 2px 0 0 var(--matrix-green);
}

.Sidebar_devBlock__YkqLy .Sidebar_groupActive__aJTET {
  color: var(--matrix-green);
  background: color-mix(in srgb, var(--matrix-green) 10%, transparent);
}

/* La guía vertical de los hijos también en verde: es un \`::before\` con \`background\`,
   no un borde, así que hay que teñir esa propiedad y no \`border-left-color\`. */
.Sidebar_devBlock__YkqLy .Sidebar_groupChildren__oIfwk::before {
  background: var(--matrix-green-dim);
}

/* El resaltado del grupo activo usa \`--dylo-ink\`, que en claro es casi negro y
   sobre este fondo desaparecería. */
.Sidebar_devBlock__YkqLy .Sidebar_groupActive__aJTET .Sidebar_label__4zS\\+M {
  color: #eaffef;
}

.Sidebar_devBlock__YkqLy .Sidebar_chevron__hdbbx {
  color: var(--matrix-green-dim);
}

/* Colapsado: el bloque se encoge al ancho del icono y no muestra etiquetas. */
.Sidebar_collapsed__PuEC6 .Sidebar_devBlock__YkqLy {
  padding: 5px;
}

/**
 * Todo el movimiento se detiene si el sistema lo pide.
 *
 * Se conservan los colores, la rejilla y los resplandores estáticos: el carácter del
 * bloque no depende de que algo se mueva. Lo que se apaga es el latido, el barrido y el
 * cursor — que además es el que más molesta a quien pidió menos animación.
 */
@media (prefers-reduced-motion: reduce) {
  .Sidebar_devBlock__YkqLy,
  .Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8 .Sidebar_icon__aHiGX,
  .Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8 .Sidebar_label__4zS\\+M::after {
    animation: none;
  }
  .Sidebar_scanline__Mhm5U {
    display: none;
  }
  .Sidebar_devBlock__YkqLy .Sidebar_groupToggle__dibI8 .Sidebar_label__4zS\\+M::after {
    opacity: 1;
  }
}

/* =====================================================================
   Módulo Developer: el sidebar también se viste
   =====================================================================

   🔑 Los colores llegan solos —\`body.dylo-dev-shell\` declara los tokens y este archivo ya dibuja con
   \`var(--dylo-*)\`—, así que aquí solo van las medidas escritas a mano, que ninguna variable puede
   cambiar: los radios de 20px y 14px de las tarjetas del menú.

   📌 El bloque Developer del propio sidebar **no se toca**: ya era verde y animado, y es de donde
   salió toda esta estética. Ahora el resto del menú se le parece en lugar de contrastar con él.

   ⚠️ \`border-radius: 50%\` se queda fuera de la lista: es el punto de estado, y es redondo a propósito. */

body.dylo-dev-shell .Sidebar_logoCard__j4yua,
body.dylo-dev-shell .Sidebar_navCard__fYsaY,
body.dylo-dev-shell .Sidebar_collapseBtn__LU91o,
body.dylo-dev-shell .Sidebar_item__IT-N6,
body.dylo-dev-shell .Sidebar_groupToggle__dibI8,
body.dylo-dev-shell .Sidebar_groupChild__JkGOS,
body.dylo-dev-shell .Sidebar_modeBtn__GgAIE,
body.dylo-dev-shell .Sidebar_navTooltip__xwDx1 {
  border-radius: 0;
}

/*
  Las tarjetas del menú reciben la misma silueta con muescas que las de la pantalla, en su medida
  chica.

  📌 \`dylo-dev-frame-only\` no se puede usar aquí: esa clase la aplica el JSX y el sidebar es un
  componente compartido con toda la plataforma. Se dibuja el patrón directo, con las mismas piezas.
*/
body.dylo-dev-shell .Sidebar_navCard__fYsaY,
body.dylo-dev-shell .Sidebar_logoCard__j4yua {
  border-color: color-mix(in srgb, var(--matrix-yellow) 30%, transparent);
  background-image: linear-gradient(
      color-mix(in srgb, var(--matrix-yellow) 45%, transparent),
      color-mix(in srgb, var(--matrix-yellow) 45%, transparent)
    ),
    linear-gradient(
      color-mix(in srgb, var(--matrix-yellow) 45%, transparent),
      color-mix(in srgb, var(--matrix-yellow) 45%, transparent)
    );
  /* Dos escuadras cortas, arriba a la izquierda y abajo a la derecha. */
  background-size: 16px 2px, 16px 2px;
  background-position: 0 0, 100% 100%;
  background-repeat: no-repeat;
}

/* =====================================================================
   Logotipo en verde de fósforo
   =====================================================================

   🔑 **Se pinta con \`mask-image\`, no con un \`<img>\` de otro color.** Los dos archivos que pidió el
   usuario son la versión negativa en gris —artes de \`#a4a6a8\` y \`#fff\` sobre fondo transparente, sin
   rectángulo de fondo—, así que su canal alfa **es exactamente la silueta del logotipo**. Usarlo como
   máscara sobre un degradado verde da el logotipo verde de verdad.

   📌 La alternativa era superponer una capa verde con \`mix-blend-mode\`. Se descartó: el resultado
   depende de lo que haya detrás y con un fondo casi negro el verde apenas se notaría. Con máscara el
   color es el que se declara, sin depender del fondo.

   ⚠️ Se copiaron a \`public/\` con **nombres sin espacios** (\`dylo-dev-logo-*.svg\`). Los originales
   viven en \`public/Logos DYLO/\` con espacios y acentos en el nombre, y una \`url()\` de CSS con espacios
   obliga a comillas y escapes que se rompen distinto en cada herramienta del camino.

   ⚠️ Y viven en \`src/v2/assets/\`, referenciados con **ruta relativa**. El primer intento los dejó en
   \`public/\` con ruta absoluta (\`url('../assets/dylo-dev-logo-full.svg')\`) suponiendo que \`css-loader\` la dejaría
   intacta: **no lo hace**, intenta resolverla como módulo y el build falla con "Can't resolve". Desde
   \`src\` con ruta relativa sí las procesa y las emite como recurso con su huella de versión. */

/*
  ⚠️ El \`<img>\` se oculta con \`opacity: 0\`, **no con \`display: none\`**. Su contenido es gris y no se
  puede recolorear desde CSS, así que hay que taparlo — pero es el que lleva \`alt="DYLO"\`, y
  \`display: none\` lo saca del árbol de accesibilidad: el logotipo dejaría de tener nombre para un
  lector de pantalla. Con opacidad cero sigue anunciándose y el dibujo lo pone el pseudo-elemento,
  que es decorativo por naturaleza.
*/
body.dylo-dev-shell .Sidebar_logo__Y3UPa {
  opacity: 0;
}

body.dylo-dev-shell .Sidebar_logoCard__j4yua {
  position: relative;
}

body.dylo-dev-shell .Sidebar_logoCard__j4yua::after {
  content: '';
  position: absolute;
  /* El mismo relleno que tenía la tarjeta para el \`<img>\`, para que no cambie de tamaño. */
  inset: 10px 14px;
  /*
    Degradado en lugar de un verde plano: la variación de arriba a abajo hace que el logotipo se lea
    como algo iluminado y no como una silueta pintada.
  */
  background: linear-gradient(
    170deg,
    var(--matrix-green) 0%,
    color-mix(in srgb, var(--matrix-green) 72%, #0b3) 55%,
    color-mix(in srgb, var(--matrix-green) 88%, #fff) 100%
  );
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  /* Resplandor de fósforo. Va en \`filter\` porque \`box-shadow\` seguiría la caja, no la silueta. */
  filter: drop-shadow(0 0 6px color-mix(in srgb, var(--matrix-green) 55%, transparent));
  pointer-events: none;
}

/*
  Contraído cambia el archivo: el símbolo suelto, sin la palabra.

  📌 Son dos archivos y no uno recortado con \`mask-position\` porque las proporciones son distintas
  —292×128 el completo y 85×128 el símbolo—, y \`contain\` sobre el completo dejaría la palabra
  aplastada en 60px de ancho.
*/
body.dylo-dev-shell .Sidebar_collapsed__PuEC6 .Sidebar_logoCard__j4yua::after {
  inset: 8px;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* =====================================================================
   Botón de contraer
   =====================================================================

   🔴 **Se quedó con el diseño viejo**: un círculo de 26px con fondo \`#151515\` escrito a mano. Ninguna
   variable podía cambiarlo, así que el tema pasó de largo — era el único elemento redondo que quedaba
   a la vista.

   📌 Ahora es una pestaña rectangular con la punta cortada del lado que asoma, como los tiradores de
   las láminas de referencia. Recortar aquí es seguro: el botón solo contiene un icono. */

body.dylo-dev-shell .Sidebar_collapseBtn__LU91o {
  width: 22px;
  height: 34px;
  right: -11px;
  border-radius: 0;
  border: 1px solid color-mix(in srgb, var(--matrix-yellow) 55%, transparent);
  background: color-mix(in srgb, #060c08 96%, transparent);
  color: var(--matrix-yellow);
  /* Punta cortada arriba y abajo del lado externo: se lee como una pieza encajada en el borde. */
  clip-path: polygon(0 0, 100% 6px, 100% calc(100% - 6px), 0 100%);
  box-shadow: 0 0 12px color-mix(in srgb, var(--matrix-yellow) 22%, transparent);
}

body.dylo-dev-shell .Sidebar_collapseBtn__LU91o:hover {
  background: color-mix(in srgb, var(--matrix-yellow) 18%, transparent);
  border-color: var(--matrix-yellow);
}

/*
  ⚠️ El foco va **por dentro** (\`box-shadow: inset\`). \`clip-path\` recorta el contorno del elemento,
  \`outline\` incluido, así que un anillo por fuera sería invisible y el botón quedaría sin marca de foco
  al recorrer con teclado.
*/
body.dylo-dev-shell .Sidebar_collapseBtn__LU91o:focus-visible {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--matrix-yellow-hot);
}

/* La opción activa marca con una barra al costado, no con una pastilla redonda. */
body.dylo-dev-shell .Sidebar_itemActive__lqCsq {
  background-image: linear-gradient(var(--matrix-yellow), var(--matrix-yellow));
  background-size: 3px 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
}

/* Tipografía de instrumento en las etiquetas del menú. */
body.dylo-dev-shell .Sidebar_item__IT-N6,
body.dylo-dev-shell .Sidebar_groupToggle__dibI8,
body.dylo-dev-shell .Sidebar_groupChild__JkGOS {
  font-family: var(--font-cyber-display, var(--font-sans));
  font-size: 10.5px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/v2/layout/Sidebar.module.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;sDAUsD;AACtD;EACE;;;;;;;;;IASE;EACF;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,UAAU;IACV,aAAa;IACb,+DAA+D;IAC/D,uBAAuB;IACvB,kFAAkF;IAClF;mDAC+C;IAC/C,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,sDAAsD;IACtD,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB;;;;;MAKE;IACF,sBAAsB;IACtB,2BAA2B;IAC3B;sBACkB;IAClB;;;;;;;MAOE;IACF,oEAAoE;IACpE,2BAA2B;IAC3B,mCAAmC;IACnC,0FAA0F;IAC1F,4CAA4C;EAC9C;;EAEA;;;;;;;;;IASE;EACF;;+EAE6E;EAC7E;IACE,oEAAoE;IACpE,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;IACE,oEAAoE;IACpE,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;;;;;;;;;;;;;;;;IAgBE;EACF;IACE;;;wHAGoH;IACpH,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;8BAC4B;EAC5B;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;;EAEA;;;;;IAKE;EACF;IACE;MACE,+BAA+B;IACjC;IACA;;MAEE,+BAA+B;IACjC;EACF;;EAEA;;;;;IAKE;;EAEF;IACE,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;;;IAGE;EACF;;qGAEmG;EACnG;IACE,aAAa;EACf;;EAEA;;;;;IAKE;EACF;IACE,oFAAqE;EACvE;EACA,yFAA4C,qBAAqB,EAAE;EACnE,yFAA4C,qBAAqB,EAAE;EACnE,yFAA4C,sBAAsB,EAAE;EACpE,yFAA4C,sBAAsB,EAAE;EACpE,yFAA4C,sBAAsB,EAAE;EACpE,yFAA4C,sBAAsB,EAAE;EACpE,yFAA4C,sBAAsB,EAAE;EACpE,6FAAgD,sBAAsB,EAAE;;EAExE;IACE;MACE,UAAU;MACV,sBAAsB;IACxB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA,+CAA+C;EAC/C;IACE;MACE,gDAAgD;MAChD,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;AACF;;;;AAIA,6CAA6C;AAC7C;EACE,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA,qFAAqF;AACrF;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,YAAY;EACZ;mEACiE;EACjE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,WAAW;EACX,6DAA6D;AAC/D;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;mEAmBmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB;4EAC0E;EAC1E,4BAA4B;EAC5B;;;;;;IAME;EACF,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;EAcE;AACF;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,qEAAqE;EACrE,YAAY;AACd;AACA,4EAA4E;AAC5E;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,yDAAyD;AAC3D;AACA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;EAUE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,sEAAsE;AACtE;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;AACA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4EAA4E;AAC9E;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,qDAAqD;AACrD;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,oEAAoE;EACpE,sDAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;;;;;;;;;;;;;;;;oEAgBoE;AACpE;EACE,uEAAuE;EACvE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yDAAyD;EACzD,kBAAkB;EAClB,2EAA2E;EAC3E,gBAAgB;EAChB;+CAC6C;EAC7C,kBAAkB;;EAElB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;;EAEpB;;;;;;;;IAQE;EACF,kCAAkC;EAClC;;;;;;;;;;;;;KAaG;EACH,gDAAgD;;EAEhD,0EAA0E;EAC1E,2EAA2E;EAC3E;oEACkE;EAClE,+DAAgD;AAClD;;AAEA;;;;CAIC;AACD;EACE;;IAEE;sEACkE;IAClE,sEAAsE;EACxE;EACA;IACE;uEACmE;IACnE,sEAAsE;EACxE;AACF;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;;;EAOE;AACF;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV;;;;;;GAMC;EACD,uDAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA,6EAA6E;AAC7E;;EAEE,0BAA0B;EAC1B,oEAAoE;EACpE,qEAAqE;EACrE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,sFAAsF;EACtF,6EAA6E;AAC/E;AACA;;EAEE,oEAAoE;EACpE,cAAc;EACd,6EAA6E;AAC/E;;AAEA;;;;EAIE;AACF;EACE,4DAA6C;AAC/C;;AAEA;EACE;;IAEE,qFAAqF;IACrF,aAAa;EACf;EACA;IACE,gDAAgD;IAChD,UAAU;EACZ;AACF;;AAEA;;;;;;EAME;AACF;EACE,YAAY;EACZ,gBAAgB;EAChB,0DAA2C;AAC7C;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA,4DAA4D;AAC5D;EACE,aAAa;AACf;;AAEA;;;;CAIC;AACD;;EAEE,oEAAoE;EACpE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,oEAAoE;AACtE;;AAEA;+EAC+E;AAC/E;EACE,mCAAmC;AACrC;;AAEA;oCACoC;AACpC;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8EAA8E;AAC9E;EACE,YAAY;AACd;;AAEA;;;;;;EAME;AACF;EACE;;;IAGE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;;;;;;;;;;yGAWyG;;AAEzG;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;;;;;;CAMC;AACD;;EAEE,uEAAuE;EACvE;;;;;;;KAOG;EACH,sEAAsE;EACtE,mCAAmC;EACnC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;8FAoB8F;;AAE9F;;;;;;CAMC;AACD;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yFAAyF;EACzF,gBAAgB;EAChB;;;GAGC;EACD;;;;;GAKC;EAED,mDAAmD;EAEnD,kBAAkB;EAElB,sBAAsB;EAEtB,qBAAqB;EACrB,+FAA+F;EAC/F,qFAAqF;EACrF,oBAAoB;AACtB;;AAEA;;;;;;CAMC;AACD;EACE,UAAU;EAEV,mDAAmD;AACrD;;AAEA;;;;;;;;;yFASyF;;AAEzF;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,2EAA2E;EAC3E,wDAAwD;EACxD,2BAA2B;EAC3B,+FAA+F;EAC/F,gEAAgE;EAChE,8EAA8E;AAChF;;AAEA;EACE,qEAAqE;EACrE,kCAAkC;AACpC;;AAEA;;;;CAIC;AACD;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA,kFAAkF;AAClF;EACE,6EAA6E;EAC7E,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,yDAAyD;AACzD;;;EAGE,wDAAwD;EACxD,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B","sourcesContent":["/* Contenedor sticky de toda la barra (transparente): apila las dos cards */\n.sidebar {\n  position: sticky;\n  top: 16px;\n  align-self: flex-start;\n  height: calc(100vh - 32px);\n  width: 248px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: width 0.22s ease;\n}\n.sidebar.collapsed {\n  width: 84px;\n}\n\n/* ============================================================\n   MÓVIL: el sidebar pasa a drawer (off-canvas)\n   ============================================================\n   Antes no había NINGUNA media query aquí, así que en un teléfono el sidebar\n   conservaba sus 248px (u 84px colapsado) y `height: calc(100vh - 32px)`: se\n   veía como una columna angosta y altísima, y al ser `sticky` se deslizaba\n   ENCIMA del contenido al hacer scroll (por eso tapaba \"Back to list\").\n\n   Ahora se saca del flujo y se muestra solo cuando el usuario lo pide con el\n   botón de menú. La animación usa **solo opacidad y escala**, nunca\n   desplazamiento, según la convención del proyecto. */\n@media (max-width: 720px) {\n  /**\n   * Drawer anclado a la DERECHA.\n   *\n   * Antes salía por la izquierda, heredado de la posición del sidebar de escritorio, y con\n   * el botón de menú también a la izquierda. Se cambió a la derecha por dos razones: es\n   * donde llega el pulgar sin recolocar la mano, y el panel aparece **desde el mismo borde\n   * donde está el botón** que lo abrió, así que la relación causa-efecto se ve. Eso era\n   * parte de la sensación de \"está raro\": el gesto y el resultado ocurrían en lados\n   * opuestos de la pantalla.\n   */\n  .sidebar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: auto;\n    height: 100vh;\n    /* Ancho cómodo para el pulgar, sin comerse toda la pantalla. */\n    width: min(88vw, 320px);\n    /* `env(safe-area-inset-*)` respeta la muesca y la barra de gestos del teléfono. */\n    padding: calc(10px + env(safe-area-inset-top, 0px)) 12px\n      calc(12px + env(safe-area-inset-bottom, 0px));\n    box-sizing: border-box;\n    z-index: 120;\n    overflow-y: auto;\n    /* Oculto por omisión: no se puede tocar ni tabular. */\n    opacity: 0;\n    visibility: hidden;\n    pointer-events: none;\n    /**\n     * ⚠️ **Solo opacidad y escala, nunca desplazamiento**, según la convención del\n     * proyecto. Un drawer normalmente se deslizaría con `translateX`; aquí se logra la\n     * misma lectura escalando desde el borde donde nace (`transform-origin: top right`):\n     * el panel crece desde la esquina del botón en lugar de aparecer de golpe.\n     */\n    transform: scale(0.94);\n    transform-origin: top right;\n    transition: opacity 0.22s ease, transform 0.24s cubic-bezier(0.22, 1, 0.36, 1),\n      visibility 0.24s;\n    /**\n     * Fondo de **cristal**, igual que el header móvil: translúcido con difuminado fuerte.\n     *\n     * Antes era opaco (`--dylo-page-bg`) y el drawer se sentía como otra pantalla encima. Con\n     * transparencia se percibe como una capa sobre el contenido, que es lo que es. El 72% es\n     * más opaco que el header a propósito: aquí hay texto de menú que debe leerse sin dudas,\n     * y las tarjetas internas ya traen su propio fondo.\n     */\n    background: color-mix(in srgb, var(--dylo-page-bg) 72%, transparent);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    /* Sombra hacia el interior de la pantalla: refuerza que es una capa sobre el contenido. */\n    box-shadow: -18px 0 40px rgba(0, 0, 0, 0.35);\n  }\n\n  /**\n   * 🔑 Las tarjetas de dentro también translúcidas.\n   *\n   * El panel ya era de cristal, pero **no se notaba**: `.logoCard` y `.navCard` llevan\n   * `--dylo-surface` opaco y entre las dos cubren casi todo el drawer, así que la\n   * transparencia solo asomaba por los 12px de padding. El efecto vive o muere aquí.\n   *\n   * La tarjeta del logo va más transparente que la de las opciones: ahí no hay texto que\n   * leer, solo el logotipo, así que aguanta más cristal sin perder legibilidad.\n   */\n  /* ⚠️ Se escriben como `.sidebar .logoCard` porque las reglas base están **después** en el\n     archivo y, con la misma especificidad, ganaría el orden aunque estas vivan en un `@media`.\n     Es la misma trampa que ya costó un intento con el encabezado del drawer. */\n  .sidebar .logoCard {\n    background: color-mix(in srgb, var(--dylo-surface) 45%, transparent);\n    backdrop-filter: blur(14px);\n    -webkit-backdrop-filter: blur(14px);\n  }\n\n  .sidebar .navCard {\n    background: color-mix(in srgb, var(--dylo-surface) 62%, transparent);\n    backdrop-filter: blur(14px);\n    -webkit-backdrop-filter: blur(14px);\n  }\n\n  /**\n   * 🔑 En móvil el menú NO scrollea por dentro: scrollea el drawer completo.\n   *\n   * El drawer ya tiene `overflow-y: auto` y `height: 100vh` unas reglas más arriba,\n   * así que dejar el scroll de `.nav` daría **dos áreas anidadas que scrollean**. En\n   * un teléfono eso es de lo más molesto que hay: el dedo mueve una o la otra según\n   * dónde empezó el gesto, y el pie del panel se quedaría fijo a media pantalla en\n   * lugar de estar al final del menú, que es donde se espera.\n   *\n   * Y el problema que motivó el scroll de escritorio aquí no existe: el drawer mide\n   * `100vh` fijo, no crece.\n   *\n   * ⚠️ Va como `.sidebar .nav` / `.sidebar .navCard` a propósito. Las reglas base\n   * están **después** en este archivo, así que con la misma especificidad ganarían\n   * por orden aunque estas vivan dentro del `@media`. Es la tercera vez que este\n   * archivo cobra esa trampa.\n   */\n  .sidebar .nav {\n    /* 🔄 21-oct-2026: `1 1 auto` y no `0 0 auto`. `.navScroll` es un flex en **fila**, así que aquí `flex` decide el\n       ancho, no el alto: con `0 0 auto` el menú medía lo que su opción más larga (\"Create Shipment\") y la pastilla\n       naranja de la opción activa se cortaba antes del borde de la tarjeta. Lo que quita el scroll interno es\n       `.sidebar .navScroll { flex: 0 0 auto }` (en la columna de la tarjeta) junto con el `min-height: auto` de aquí. */\n    flex: 1 1 auto;\n    min-height: auto;\n    overflow-y: visible;\n    overscroll-behavior: auto;\n  }\n  /* Sin área que scrollee no hay nada que insinuar, y el degradado quedaría flotando\n     encima de las opciones. */\n  .sidebar .navScroll {\n    flex: 0 0 auto;\n  }\n  .sidebar .navScroll::after {\n    display: none;\n  }\n\n  /**\n   * Sin soporte de `backdrop-filter`, todo vuelve a ser opaco.\n   *\n   * Translúcido y **sin** difuminar dejaría el menú ilegible sobre el contenido: se leerían\n   * los dos textos superpuestos. Es preferible perder el efecto que la legibilidad.\n   */\n  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {\n    .sidebar {\n      background: var(--dylo-page-bg);\n    }\n    .sidebar .logoCard,\n    .sidebar .navCard {\n      background: var(--dylo-surface);\n    }\n  }\n\n  /**\n   * Ya no hacen falta las anulaciones de `.collapsed` aquí: el componente **no aplica esa\n   * clase en móvil** (ver `shownCollapsed` en `Sidebar.tsx`), así que el drawer siempre se\n   * dibuja como el sidebar extendido — logo completo y opciones con texto. Antes se parchaba\n   * desde el CSS y el logo seguía siendo el símbolo, porque cuál cargar lo decide JavaScript.\n   */\n\n  .sidebar.mobileOpen {\n    opacity: 1;\n    visibility: visible;\n    pointer-events: auto;\n    transform: scale(1);\n  }\n\n  /**\n   * Colapsar no tiene sentido en un drawer, y **dejar el botón visible era el otro motivo\n   * de que se sintiera como una adaptación mal hecha**: un menú móvil no se \"contrae\".\n   */\n  /* 🔄 21-oct-2026: `.sidebar .collapseBtn` y no `.collapseBtn` solo. La regla base está **después** en este archivo y,\n     con la misma especificidad, ganaba aunque esta viva en el `@media`: el botón seguía saliendo en el cajón, medio\n     cortado contra el borde derecho de la pantalla. Es la trampa de las notas de arriba, otra vez. */\n  .sidebar .collapseBtn {\n    display: none;\n  }\n\n  /**\n   * Entrada escalonada de las opciones.\n   *\n   * Aparecen en cascada en lugar de todas a la vez: da la sensación de que el menú se\n   * despliega y guía la vista hacia abajo. Solo opacidad y escala.\n   */\n  .sidebar.mobileOpen .nav > * {\n    animation: dylo-drawer-item 0.26s cubic-bezier(0.22, 1, 0.36, 1) both;\n  }\n  .sidebar.mobileOpen .nav > *:nth-child(1) { animation-delay: 40ms; }\n  .sidebar.mobileOpen .nav > *:nth-child(2) { animation-delay: 70ms; }\n  .sidebar.mobileOpen .nav > *:nth-child(3) { animation-delay: 100ms; }\n  .sidebar.mobileOpen .nav > *:nth-child(4) { animation-delay: 130ms; }\n  .sidebar.mobileOpen .nav > *:nth-child(5) { animation-delay: 155ms; }\n  .sidebar.mobileOpen .nav > *:nth-child(6) { animation-delay: 175ms; }\n  .sidebar.mobileOpen .nav > *:nth-child(7) { animation-delay: 195ms; }\n  .sidebar.mobileOpen .nav > *:nth-child(n + 8) { animation-delay: 210ms; }\n\n  @keyframes dylo-drawer-item {\n    from {\n      opacity: 0;\n      transform: scale(0.97);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  /* Quien pidió menos movimiento no lo recibe. */\n  @media (prefers-reduced-motion: reduce) {\n    .sidebar {\n      transition: opacity 0.12s ease, visibility 0.12s;\n      transform: none;\n    }\n    .sidebar.mobileOpen {\n      transform: none;\n    }\n    .sidebar.mobileOpen .nav > * {\n      animation: none;\n    }\n  }\n}\n\n\n\n/* Card del logo (separada de las opciones) */\n.logoCard {\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--dylo-sidebar-border);\n  border-radius: 20px;\n  box-shadow: var(--shadow-card);\n  padding: 10px 14px;\n  height: 72px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.logo {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n/* El card mantiene su altura fija; el símbolo (vertical) llena el alto disponible. */\n.collapsed .logoCard {\n  padding: 8px;\n}\n.collapsed .logo {\n  height: 100%;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n/* Card de navegación */\n.navCard {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--dylo-sidebar-border);\n  border-radius: 20px;\n  box-shadow: var(--shadow-card);\n  padding: 18px 14px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Botón de colapsar: sobre el borde derecho, a la altura de la primera opción */\n.collapseBtn {\n  position: absolute;\n  right: -13px;\n  /* Centrado vertical con la primera opción (Dashboard):\n     padding-top navCard 18 + medio item (~21) - medio botón (13) */\n  top: 26px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1.5px solid var(--dylo-sidebar-border);\n  background: #151515;\n  color: var(--dylo-collapse-icon);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n  z-index: 20;\n  transition: transform 0.22s ease, background-color 0.15s ease;\n}\n.collapsed .collapseBtn {\n  transform: rotate(180deg);\n}\n\n/* ============================================================\n   Navegación — la parte que crece y scrollea\n   ============================================================\n   🔑 El menú siguió creciendo y llegó el punto en que no cabía: `.nav` no tenía\n   `overflow`, así que se desbordaba de `.navCard`, el `.spacer` colapsaba a 0 y\n   **`.footerNav` (Mode y My account) se iba fuera de la tarjeta**.\n\n   La solución no es `position: sticky` en el pie, es darle a `.nav` el papel de\n   absorber el crecimiento: `flex: 1` + `min-height: 0` + su propio scroll. Con\n   eso `.footerNav` queda naturalmente clavado al fondo de la tarjeta por ser su\n   hermano fuera del área que scrollea.\n\n   ⚠️ Es mejor que `sticky` justamente por lo que ya tropezó este archivo:\n   `overflow` en un ancestro **rompe** `position: sticky` de sus descendientes. Si\n   el scroll viviera en `.navCard`, un pie sticky dentro dejaría de funcionar. Así\n   el scroll está en `.nav` y el pie ni lo necesita.\n\n   📌 `min-height: 0` no es opcional: el mínimo por omisión de un ítem flex es el\n   tamaño de su contenido, así que sin esto `.nav` se niega a encogerse por debajo\n   de la altura de todas las opciones juntas y no scrollea nunca. */\n.nav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  /* Al llegar al final del menú, el scroll NO se contagia a la página. Sin esto,\n     seguir girando la rueda mueve el contenido de atrás y se siente roto. */\n  overscroll-behavior: contain;\n  /**\n   * Barra de scroll oculta, a petición: lo que importa es que el sidebar no crezca\n   * a lo alto, y una barra ahí competiría visualmente con las opciones.\n   *\n   * ⚠️ Contrapartida asumida: sin barra no hay señal de que haya más contenido\n   * abajo. Se mitiga con el degradado de `.navCard::after`, que sí avisa.\n   */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.nav::-webkit-scrollbar {\n  display: none;\n}\n\n/**\n * Envoltura del área que scrollea.\n *\n * Existe solo para poder anclar el degradado al **borde inferior del scroll**.\n *\n * 🔑 Por qué hace falta y no basta un pseudo-elemento:\n * - dentro de `.nav` se desplazaría con el contenido en lugar de quedarse en el\n *   borde, y\n * - sobre `.navCard` habría que posicionarlo con un `bottom` calculado a partir\n *   del alto del pie, que es un número mágico: se rompió en cuanto se agregó el\n *   bloque de Desarrollador encima del divisor.\n *\n * Con la envoltura, el degradado queda pegado al final del scroll pase lo que pase\n * debajo.\n */\n.navScroll {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n}\n.navScroll::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 22px;\n  pointer-events: none;\n  background: linear-gradient(to top, var(--dylo-surface), transparent);\n  opacity: 0.9;\n}\n/* El wrapper del tooltip debe ocupar todo el ancho para no romper el item */\n.navTooltip {\n  display: block;\n  width: 100%;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 11px 14px;\n  border-radius: 12px;\n  color: var(--dylo-text);\n  font-size: 14.5px;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.item:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);\n  color: var(--dylo-ink);\n}\n.item .icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  color: currentColor;\n}\n.itemActive {\n  background: var(--dylo-orange);\n  color: #fff;\n}\n.itemActive:hover {\n  background: var(--dylo-orange-hover);\n  color: #fff;\n}\n\n.collapsed .item {\n  justify-content: center;\n  padding: 11px 0;\n}\n.collapsed .label {\n  display: none;\n}\n\n/**\n * Pie del sidebar: el divisor, Mode y My account.\n *\n * `flex-shrink: 0` es la otra mitad del arreglo. Sin él, cuando el menú no cabe\n * el navegador reparte la falta de espacio entre los dos hermanos y el pie se\n * empieza a comprimir —que es la versión sutil del mismo problema— en lugar de\n * dejar que `.nav` scrollee.\n *\n * Ya no hace falta un `.spacer`: `.nav` tiene `flex: 1` y llena el hueco cuando\n * hay pocas opciones, así que el pie queda abajo igual.\n */\n.footerNav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-top: 14px;\n  border-top: 1px solid var(--dylo-line);\n  flex-shrink: 0;\n}\n\n.modeBtn {\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: var(--font-sans);\n}\n\n/* ===== Grupos colapsables del menú (submenú \"Shipments\") ===== */\n.group {\n  display: flex;\n  flex-direction: column;\n}\n\n/* El toggle reutiliza .item para heredar tamaño, tipografía y hover */\n.groupToggle {\n  width: 100%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font-sans);\n  text-align: left;\n}\n/* Se resalta cuando alguna vista del grupo está activa */\n.groupActive .label {\n  color: var(--dylo-ink);\n  font-weight: 600;\n}\n\n.chevron {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  opacity: 0.7;\n  transition: transform 0.22s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease;\n}\n.chevronOpen {\n  transform: rotate(180deg);\n  opacity: 1;\n}\n\n.groupChildren {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 2px 0 2px 0;\n}\n/* Guía vertical que agrupa visualmente a los hijos */\n.groupChildren::before {\n  content: '';\n  position: absolute;\n  left: 20px;\n  top: 2px;\n  bottom: 2px;\n  width: 1.5px;\n  border-radius: 2px;\n  background: var(--dylo-line);\n}\n\n.groupChild {\n  /* Solo opacidad: sin translate, para no disparar barras de scroll */\n  animation: dylo-fade-in 0.24s ease both;\n}\n\n.itemNested {\n  padding-left: 34px;\n  font-size: 13px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .groupChild,\n  .chevron {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n/* ============================================================\n   Sección Desarrollador — paleta matrix\n   ============================================================\n   🔑 Los colores viven en **variables con alcance a este bloque**, no como valores\n   fijos sueltos por la regla. Dos razones:\n\n   1. Reescribir los tokens dentro de `.devBlock` hace que todo lo que herede de\n      ellos —el `.item`, el hover, el estado activo, el chevron del grupo— se tiña\n      solo, sin duplicar cada regla. Es el mismo recurso que usa la card\n      `spotlight` del dashboard.\n   2. Si estos colores se escribieran en los tokens globales o sin acotar, se\n      filtrarían al resto de la aplicación y **romperían el modo claro**: un verde\n      neón sobre fondo blanco es ilegible.\n\n   Verde y negro fijos a propósito, iguales en claro y oscuro: la sección tiene que\n   leerse como \"esto es otra cosa, no es la aplicación normal\" en los dos temas. Es\n   la única parte del sistema que ignora el tema, y es deliberado. */\n.devBlock {\n  /* No se comprime: cuando el menú no cabe, el que scrollea es `.nav`. */\n  flex-shrink: 0;\n  margin-top: 10px;\n  padding: 7px;\n  border-radius: 14px;\n  /* Ancla de las capas decorativas, que van en absoluto. */\n  position: relative;\n  /* Recorta el barrido del escáner y los pulsos en los bordes redondeados. */\n  overflow: hidden;\n  /* Aísla el apilamiento para que los z-index de dentro no compitan con el resto\n     del sidebar ni con el botón de colapsar. */\n  isolation: isolate;\n\n  --matrix-green: #39ff88;\n  --matrix-green-dim: #1f7a44;\n  --matrix-bg: #050806;\n\n  /**\n   * Fondo en tres capas:\n   * 1. rejilla fina de PCB (dos gradientes cruzados),\n   * 2. resplandor difuso que sube desde el fondo, y\n   * 3. el negro base.\n   *\n   * Se hace con gradientes y no con una imagen porque escala a cualquier tamaño sin\n   * pedir un archivo extra, y porque el bloque cambia de ancho al colapsar el sidebar.\n   */\n  background-color: var(--matrix-bg);\n  background-image: linear-gradient(\n      color-mix(in srgb, var(--matrix-green) 5%, transparent) 1px,\n      transparent 1px\n    ),\n    linear-gradient(\n      90deg,\n      color-mix(in srgb, var(--matrix-green) 5%, transparent) 1px,\n      transparent 1px\n    ),\n    radial-gradient(\n      120% 80% at 50% 130%,\n      color-mix(in srgb, var(--matrix-green) 14%, transparent),\n      transparent 70%\n    );\n  background-size: 14px 14px, 14px 14px, 100% 100%;\n\n  border: 1px solid color-mix(in srgb, var(--matrix-green) 34%, transparent);\n  /* Doble resplandor: uno interior de terminal y uno exterior que respira. */\n  box-shadow: inset 0 0 22px color-mix(in srgb, var(--matrix-green) 9%, transparent),\n    0 0 0 0 color-mix(in srgb, var(--matrix-green) 30%, transparent);\n  animation: dev-breathe 3.6s ease-in-out infinite;\n}\n\n/*\n  El resplandor exterior late. Se anima `box-shadow` y NO `transform`: escalar el bloque\n  movería el pie del sidebar en cada latido, que es justo el tipo de animación que este\n  proyecto tiene prohibida por las barras de scroll parásitas.\n*/\n@keyframes dev-breathe {\n  0%,\n  100% {\n    box-shadow: inset 0 0 22px color-mix(in srgb, var(--matrix-green) 9%, transparent),\n      0 0 6px color-mix(in srgb, var(--matrix-green) 12%, transparent);\n    border-color: color-mix(in srgb, var(--matrix-green) 30%, transparent);\n  }\n  50% {\n    box-shadow: inset 0 0 26px color-mix(in srgb, var(--matrix-green) 14%, transparent),\n      0 0 14px color-mix(in srgb, var(--matrix-green) 22%, transparent);\n    border-color: color-mix(in srgb, var(--matrix-green) 52%, transparent);\n  }\n}\n\n/* El contenido va sobre la decoración. */\n.devContent {\n  position: relative;\n  z-index: 1;\n}\n\n/**\n * Barrido de escáner.\n *\n * Una línea que recorre el bloque de arriba abajo, como el refresco de un monitor\n * viejo. Se anima `top`, y es seguro **porque el elemento está en absoluto**: no\n * participa del flujo, así que no puede empujar nada ni disparar una barra de scroll.\n * Es la misma excepción que ya se usó con el vehículo del conector.\n */\n.scanline {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 34px;\n  pointer-events: none;\n  z-index: 0;\n  background: linear-gradient(\n    to bottom,\n    transparent,\n    color-mix(in srgb, var(--matrix-green) 10%, transparent) 45%,\n    color-mix(in srgb, var(--matrix-green) 18%, transparent) 50%,\n    transparent\n  );\n  animation: dev-scan 5.5s linear infinite;\n}\n\n@keyframes dev-scan {\n  from {\n    top: -34px;\n    opacity: 0;\n  }\n  12% {\n    opacity: 1;\n  }\n  88% {\n    opacity: 1;\n  }\n  to {\n    top: 100%;\n    opacity: 0;\n  }\n}\n\n/* Se reescriben los tokens que consume `.item`, así hereda todo el bloque. */\n.devBlock .item,\n.devBlock .groupToggle {\n  color: var(--matrix-green);\n  /* Monoespaciada: es la señal más rápida de \"herramienta técnica\". */\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 12.5px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  /* Resplandor del texto, como fósforo en un CRT. Muy leve: más y se vuelve ilegible. */\n  text-shadow: 0 0 6px color-mix(in srgb, var(--matrix-green) 45%, transparent);\n}\n.devBlock .item:hover,\n.devBlock .groupToggle:hover {\n  background: color-mix(in srgb, var(--matrix-green) 14%, transparent);\n  color: #eaffef;\n  text-shadow: 0 0 9px color-mix(in srgb, var(--matrix-green) 75%, transparent);\n}\n\n/**\n * El icono del procesador late, y el latido está **desfasado** del resplandor del\n * bloque (3.6s vs 2.4s). Si fueran iguales todo pulsaría al unísono y se leería como\n * una sola animación en bucle; desfasados parece actividad.\n */\n.devBlock .groupToggle .icon {\n  animation: dev-chip 2.4s ease-in-out infinite;\n}\n\n@keyframes dev-chip {\n  0%,\n  100% {\n    filter: drop-shadow(0 0 1px color-mix(in srgb, var(--matrix-green) 40%, transparent));\n    opacity: 0.85;\n  }\n  50% {\n    filter: drop-shadow(0 0 5px var(--matrix-green));\n    opacity: 1;\n  }\n}\n\n/**\n * Cursor de terminal parpadeando al final de la etiqueta del grupo.\n *\n * Se dibuja con `::after` sobre el `.label` para no meter un nodo más en el TSX, y usa\n * `opacity` en pasos duros (`steps`) porque un cursor de consola no se desvanece: está\n * o no está.\n */\n.devBlock .groupToggle .label::after {\n  content: '_';\n  margin-left: 3px;\n  animation: dev-caret 1.1s steps(1) infinite;\n}\n\n@keyframes dev-caret {\n  0%,\n  49% {\n    opacity: 1;\n  }\n  50%,\n  100% {\n    opacity: 0;\n  }\n}\n\n/* Colapsado no hay etiqueta, así que el cursor no aplica. */\n.collapsed .devBlock .groupToggle .label::after {\n  content: none;\n}\n\n/*\n  El estado activo NO usa el naranja de marca: si un ítem de esta sección se\n  pintara naranja, dejaría de leerse como parte del bloque y parecería un error de\n  estilo. Verde sólido sobre negro mantiene la unidad.\n*/\n.devBlock .itemActive,\n.devBlock .itemActive:hover {\n  background: color-mix(in srgb, var(--matrix-green) 22%, transparent);\n  color: #eaffef;\n  box-shadow: inset 2px 0 0 var(--matrix-green);\n}\n\n.devBlock .groupActive {\n  color: var(--matrix-green);\n  background: color-mix(in srgb, var(--matrix-green) 10%, transparent);\n}\n\n/* La guía vertical de los hijos también en verde: es un `::before` con `background`,\n   no un borde, así que hay que teñir esa propiedad y no `border-left-color`. */\n.devBlock .groupChildren::before {\n  background: var(--matrix-green-dim);\n}\n\n/* El resaltado del grupo activo usa `--dylo-ink`, que en claro es casi negro y\n   sobre este fondo desaparecería. */\n.devBlock .groupActive .label {\n  color: #eaffef;\n}\n\n.devBlock .chevron {\n  color: var(--matrix-green-dim);\n}\n\n/* Colapsado: el bloque se encoge al ancho del icono y no muestra etiquetas. */\n.collapsed .devBlock {\n  padding: 5px;\n}\n\n/**\n * Todo el movimiento se detiene si el sistema lo pide.\n *\n * Se conservan los colores, la rejilla y los resplandores estáticos: el carácter del\n * bloque no depende de que algo se mueva. Lo que se apaga es el latido, el barrido y el\n * cursor — que además es el que más molesta a quien pidió menos animación.\n */\n@media (prefers-reduced-motion: reduce) {\n  .devBlock,\n  .devBlock .groupToggle .icon,\n  .devBlock .groupToggle .label::after {\n    animation: none;\n  }\n  .scanline {\n    display: none;\n  }\n  .devBlock .groupToggle .label::after {\n    opacity: 1;\n  }\n}\n\n/* =====================================================================\n   Módulo Developer: el sidebar también se viste\n   =====================================================================\n\n   🔑 Los colores llegan solos —`body.dylo-dev-shell` declara los tokens y este archivo ya dibuja con\n   `var(--dylo-*)`—, así que aquí solo van las medidas escritas a mano, que ninguna variable puede\n   cambiar: los radios de 20px y 14px de las tarjetas del menú.\n\n   📌 El bloque Developer del propio sidebar **no se toca**: ya era verde y animado, y es de donde\n   salió toda esta estética. Ahora el resto del menú se le parece en lugar de contrastar con él.\n\n   ⚠️ `border-radius: 50%` se queda fuera de la lista: es el punto de estado, y es redondo a propósito. */\n\n:global(body.dylo-dev-shell) .logoCard,\n:global(body.dylo-dev-shell) .navCard,\n:global(body.dylo-dev-shell) .collapseBtn,\n:global(body.dylo-dev-shell) .item,\n:global(body.dylo-dev-shell) .groupToggle,\n:global(body.dylo-dev-shell) .groupChild,\n:global(body.dylo-dev-shell) .modeBtn,\n:global(body.dylo-dev-shell) .navTooltip {\n  border-radius: 0;\n}\n\n/*\n  Las tarjetas del menú reciben la misma silueta con muescas que las de la pantalla, en su medida\n  chica.\n\n  📌 `dylo-dev-frame-only` no se puede usar aquí: esa clase la aplica el JSX y el sidebar es un\n  componente compartido con toda la plataforma. Se dibuja el patrón directo, con las mismas piezas.\n*/\n:global(body.dylo-dev-shell) .navCard,\n:global(body.dylo-dev-shell) .logoCard {\n  border-color: color-mix(in srgb, var(--matrix-yellow) 30%, transparent);\n  background-image: linear-gradient(\n      color-mix(in srgb, var(--matrix-yellow) 45%, transparent),\n      color-mix(in srgb, var(--matrix-yellow) 45%, transparent)\n    ),\n    linear-gradient(\n      color-mix(in srgb, var(--matrix-yellow) 45%, transparent),\n      color-mix(in srgb, var(--matrix-yellow) 45%, transparent)\n    );\n  /* Dos escuadras cortas, arriba a la izquierda y abajo a la derecha. */\n  background-size: 16px 2px, 16px 2px;\n  background-position: 0 0, 100% 100%;\n  background-repeat: no-repeat;\n}\n\n/* =====================================================================\n   Logotipo en verde de fósforo\n   =====================================================================\n\n   🔑 **Se pinta con `mask-image`, no con un `<img>` de otro color.** Los dos archivos que pidió el\n   usuario son la versión negativa en gris —artes de `#a4a6a8` y `#fff` sobre fondo transparente, sin\n   rectángulo de fondo—, así que su canal alfa **es exactamente la silueta del logotipo**. Usarlo como\n   máscara sobre un degradado verde da el logotipo verde de verdad.\n\n   📌 La alternativa era superponer una capa verde con `mix-blend-mode`. Se descartó: el resultado\n   depende de lo que haya detrás y con un fondo casi negro el verde apenas se notaría. Con máscara el\n   color es el que se declara, sin depender del fondo.\n\n   ⚠️ Se copiaron a `public/` con **nombres sin espacios** (`dylo-dev-logo-*.svg`). Los originales\n   viven en `public/Logos DYLO/` con espacios y acentos en el nombre, y una `url()` de CSS con espacios\n   obliga a comillas y escapes que se rompen distinto en cada herramienta del camino.\n\n   ⚠️ Y viven en `src/v2/assets/`, referenciados con **ruta relativa**. El primer intento los dejó en\n   `public/` con ruta absoluta (`url('../assets/dylo-dev-logo-full.svg')`) suponiendo que `css-loader` la dejaría\n   intacta: **no lo hace**, intenta resolverla como módulo y el build falla con \"Can't resolve\". Desde\n   `src` con ruta relativa sí las procesa y las emite como recurso con su huella de versión. */\n\n/*\n  ⚠️ El `<img>` se oculta con `opacity: 0`, **no con `display: none`**. Su contenido es gris y no se\n  puede recolorear desde CSS, así que hay que taparlo — pero es el que lleva `alt=\"DYLO\"`, y\n  `display: none` lo saca del árbol de accesibilidad: el logotipo dejaría de tener nombre para un\n  lector de pantalla. Con opacidad cero sigue anunciándose y el dibujo lo pone el pseudo-elemento,\n  que es decorativo por naturaleza.\n*/\n:global(body.dylo-dev-shell) .logo {\n  opacity: 0;\n}\n\n:global(body.dylo-dev-shell) .logoCard {\n  position: relative;\n}\n\n:global(body.dylo-dev-shell) .logoCard::after {\n  content: '';\n  position: absolute;\n  /* El mismo relleno que tenía la tarjeta para el `<img>`, para que no cambie de tamaño. */\n  inset: 10px 14px;\n  /*\n    Degradado en lugar de un verde plano: la variación de arriba a abajo hace que el logotipo se lea\n    como algo iluminado y no como una silueta pintada.\n  */\n  background: linear-gradient(\n    170deg,\n    var(--matrix-green) 0%,\n    color-mix(in srgb, var(--matrix-green) 72%, #0b3) 55%,\n    color-mix(in srgb, var(--matrix-green) 88%, #fff) 100%\n  );\n  -webkit-mask-image: url('../assets/dylo-dev-logo-full.svg');\n  mask-image: url('../assets/dylo-dev-logo-full.svg');\n  -webkit-mask-size: contain;\n  mask-size: contain;\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n  /* Resplandor de fósforo. Va en `filter` porque `box-shadow` seguiría la caja, no la silueta. */\n  filter: drop-shadow(0 0 6px color-mix(in srgb, var(--matrix-green) 55%, transparent));\n  pointer-events: none;\n}\n\n/*\n  Contraído cambia el archivo: el símbolo suelto, sin la palabra.\n\n  📌 Son dos archivos y no uno recortado con `mask-position` porque las proporciones son distintas\n  —292×128 el completo y 85×128 el símbolo—, y `contain` sobre el completo dejaría la palabra\n  aplastada en 60px de ancho.\n*/\n:global(body.dylo-dev-shell) .collapsed .logoCard::after {\n  inset: 8px;\n  -webkit-mask-image: url('../assets/dylo-dev-logo-mark.svg');\n  mask-image: url('../assets/dylo-dev-logo-mark.svg');\n}\n\n/* =====================================================================\n   Botón de contraer\n   =====================================================================\n\n   🔴 **Se quedó con el diseño viejo**: un círculo de 26px con fondo `#151515` escrito a mano. Ninguna\n   variable podía cambiarlo, así que el tema pasó de largo — era el único elemento redondo que quedaba\n   a la vista.\n\n   📌 Ahora es una pestaña rectangular con la punta cortada del lado que asoma, como los tiradores de\n   las láminas de referencia. Recortar aquí es seguro: el botón solo contiene un icono. */\n\n:global(body.dylo-dev-shell) .collapseBtn {\n  width: 22px;\n  height: 34px;\n  right: -11px;\n  border-radius: 0;\n  border: 1px solid color-mix(in srgb, var(--matrix-yellow) 55%, transparent);\n  background: color-mix(in srgb, #060c08 96%, transparent);\n  color: var(--matrix-yellow);\n  /* Punta cortada arriba y abajo del lado externo: se lee como una pieza encajada en el borde. */\n  clip-path: polygon(0 0, 100% 6px, 100% calc(100% - 6px), 0 100%);\n  box-shadow: 0 0 12px color-mix(in srgb, var(--matrix-yellow) 22%, transparent);\n}\n\n:global(body.dylo-dev-shell) .collapseBtn:hover {\n  background: color-mix(in srgb, var(--matrix-yellow) 18%, transparent);\n  border-color: var(--matrix-yellow);\n}\n\n/*\n  ⚠️ El foco va **por dentro** (`box-shadow: inset`). `clip-path` recorta el contorno del elemento,\n  `outline` incluido, así que un anillo por fuera sería invisible y el botón quedaría sin marca de foco\n  al recorrer con teclado.\n*/\n:global(body.dylo-dev-shell) .collapseBtn:focus-visible {\n  outline: none;\n  box-shadow: inset 0 0 0 2px var(--matrix-yellow-hot);\n}\n\n/* La opción activa marca con una barra al costado, no con una pastilla redonda. */\n:global(body.dylo-dev-shell) .itemActive {\n  background-image: linear-gradient(var(--matrix-yellow), var(--matrix-yellow));\n  background-size: 3px 100%;\n  background-position: 0 0;\n  background-repeat: no-repeat;\n}\n\n/* Tipografía de instrumento en las etiquetas del menú. */\n:global(body.dylo-dev-shell) .item,\n:global(body.dylo-dev-shell) .groupToggle,\n:global(body.dylo-dev-shell) .groupChild {\n  font-family: var(--font-cyber-display, var(--font-sans));\n  font-size: 10.5px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__Oyk2S`,
	"collapsed": `Sidebar_collapsed__PuEC6`,
	"logoCard": `Sidebar_logoCard__j4yua`,
	"navCard": `Sidebar_navCard__fYsaY`,
	"nav": `Sidebar_nav__lOtqS`,
	"navScroll": `Sidebar_navScroll__5dU7Q`,
	"mobileOpen": `Sidebar_mobileOpen__m76Nu`,
	"collapseBtn": `Sidebar_collapseBtn__LU91o`,
	"dylo-drawer-item": `Sidebar_dylo-drawer-item__2-5AE`,
	"logo": `Sidebar_logo__Y3UPa`,
	"navTooltip": `Sidebar_navTooltip__xwDx1`,
	"item": `Sidebar_item__IT-N6`,
	"icon": `Sidebar_icon__aHiGX`,
	"itemActive": `Sidebar_itemActive__lqCsq`,
	"label": `Sidebar_label__4zS+M`,
	"footerNav": `Sidebar_footerNav__dBA0h`,
	"modeBtn": `Sidebar_modeBtn__GgAIE`,
	"group": `Sidebar_group__pWsGr`,
	"groupToggle": `Sidebar_groupToggle__dibI8`,
	"groupActive": `Sidebar_groupActive__aJTET`,
	"chevron": `Sidebar_chevron__hdbbx`,
	"chevronOpen": `Sidebar_chevronOpen__h2oux`,
	"groupChildren": `Sidebar_groupChildren__oIfwk`,
	"groupChild": `Sidebar_groupChild__JkGOS`,
	"dylo-fade-in": `Sidebar_dylo-fade-in__UBGmS`,
	"itemNested": `Sidebar_itemNested__Nusuu`,
	"devBlock": `Sidebar_devBlock__YkqLy`,
	"dev-breathe": `Sidebar_dev-breathe__f4Iyi`,
	"devContent": `Sidebar_devContent__ObclH`,
	"scanline": `Sidebar_scanline__Mhm5U`,
	"dev-scan": `Sidebar_dev-scan__F9r8p`,
	"dev-chip": `Sidebar_dev-chip__8avMi`,
	"dev-caret": `Sidebar_dev-caret__cW5R2`
};
export default ___CSS_LOADER_EXPORT___;
